import React, { useEffect, useState } from 'react';
import StatsGrid from './StatsGrid';
import RecentPurchases from './RecentPurchases';
import { API } from '../api';

const FinanceTab = ({ onUserClick }) => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOverview = async () => {
      setLoading(true);
      const result = await API.finance.getOverview();
      if (result.success) {
        setOverview(result.data);
      }
      setLoading(false);
    };

    loadOverview();
  }, []);

  return (
    <div className="tab-content">
      <StatsGrid stats={overview} loading={loading} />
      <RecentPurchases onUserClick={onUserClick} />
    </div>
  );
};

export default FinanceTab;
